export const GET_ELIGIABLE_INIT_test = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      UId: "1",
      RealName: "张三",
      IdCard: "123456",
      HousingUnit: "2",
      EligiblePeople: [
        {
          RealName: "张三",
          Id: "1",
          IdCard: "123456",
          IsPrimary: "1",
          Relationship: "本人"
        },
        {
          RealName: "张氏",
          Id: "2",
          IdCard: "43072319881002645X",
          IsPrimary: "2",
          Relationship: "夫妻"
        }
      ],
      MinorPeople: [
        {
          RealName: "张大子",
          Id: "3",
          IdCard: "43072320081002645X",
          IsPrimary: "2",
          Relationship: "子女"
        },
        {
          RealName: "张次子",
          Id: "4",
          IdCard: "43072320091002645X",
          IsPrimary: "2",
          Relationship: "子女"
        }
      ]
    }
  };
  resolve(data);
});

export const GET_ELIGIABLE_INIT_test1 = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      UId: "66f294d1feb33c162cc86f1c",
      RealName: "黄治华",
      IdCard: "43072319991102645X",
      HousingUnit: "",
      Maritalstatus: "",
      underAgestatus: "",
      EligiblePeople: [],
      MinorPeople: []
    }
  };
  resolve(data);
});

export const GET_FAMILY_MEMBER_LIST_test = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      PageIndex: 1,
      PageSize: 10,
      RecordCount: 200,
      PageCount: 20,
      DataList: [
        {
          EnterDjbh: "123",
          EnterTime: "2024",
          State: 3,
          RemainTime: "",
          UID: "88"
        },
        {
          EnterDjbh: "1234",
          EnterTime: "2025",
          State: 0,
          RemainTime: "60",
          UID: "88"
        }
      ]
    }
  };
  resolve(data);
});

export const GET_FAMILY_MEMBER_LIST_test1 = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      PageIndex: 1,
      PageSize: 10,
      RecordCount: 1,
      PageCount: 1,
      DataList: [
        {
          EnterDjbh: "TCY202409240000002",
          EnterTime: "2024/9/24 18:30:41",
          State: "-1",
          RemainTime: "",
          UID: "66f294d1feb33c162cc86f1c"
        }
      ]
    }
  };
  resolve(data);
});

export const PREVIEW_FAMILY_MEMBER_test = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      HousingUnit: "2",
      MaritalStatus: "已婚",
      underAgestatus: "否",
      EligiblePeople: [
        {
          RealName: "张三",
          Id: "1",
          IdCard: "123456",
          IsPrimary: "1",
          Relationship: "本人"
        },
        {
          RealName: "张氏",
          Id: "2",
          IdCard: "43072319881002645X",
          IsPrimary: "2",
          Relationship: "夫妻"
        },
        {
          RealName: "张三",
          Id: "1",
          IdCard: "123456",
          IsPrimary: "2",
          Relationship: "本人"
        },
      ],
      MinorPeople: [
        {
          RealName: "张大子",
          Id: "3",
          IdCard: "43072320081002645X",
          IsPrimary: "2",
          Relationship: "子女"
        },
        {
          RealName: "张次子",
          Id: "4",
          IdCard: "43072320091002645X",
          IsPrimary: "2",
          Relationship: "子女"
        }
      ],
      TermOfValidity: 60
    }
  };
  resolve(data);
});

export const PREVIEW_FAMILY_MEMBER_test1 = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      HousingUnit: "",
      MaritalStatus: "",
      underAgestatus: "否",
      EligiblePeople: [
        {
          RealName: "黄治华",
          Id: "2019585",
          IdCard: "43072319991102645X",
          IsPrimary: "1",
          Relationship: "本人"
        }
      ],
      MinorPeople: [],
      TermofValidity: "60"
    }
  };
  resolve(data);
});



// WEBPACK FOOTER //
// ./src/pages/familyEnter/index.js